import { z } from 'zod';

export const validateParameters = z.object({
  height: z.number({ message: 'Field is required' }).min(50).max(200),
  weight: z.number({ message: 'Field is required' }).min(20).max(100),
  chest: z.number({ message: 'Field is required' }).min(30).max(200),
  waist: z.number({ message: 'Field is required' }).min(30).max(100),
  hips: z.number({ message: 'Field is required' }).min(30).max(150)
});
